import React from 'react';
import { useNavigate } from 'react-router-dom';

const GradingHistory = ({ submissionHistory, loadingSubmissions, formatDate }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Grading History</h3>
      </div>
      <div className="px-4 py-3">
        {loadingSubmissions ? (
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-600"></div>
          </div>
        ) : submissionHistory.length > 0 ? (
          <div className="space-y-4">
            {submissionHistory.map((submission) => (
              <div key={submission.id} className="flex items-center justify-between border-b border-gray-200 last:border-0 pb-4 last:pb-0">
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {submission.grading_service_name} #{submission.submission_number}
                  </p>
                  <p className="text-sm text-gray-500">
                    Grade: {submission.grade || 'Pending'}
                  </p>
                  <p className="text-sm text-gray-500">
                    {formatDate(submission.date_received, { includeTime: true })}
                  </p>
                </div>
                <button
                  onClick={() => navigate(`/submissions/${submission.id}`)}
                  className="text-sm text-indigo-600 hover:text-indigo-900"
                >
                  View Details
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">No grading history available</p>
        )}
      </div>
    </div>
  );
};

export default GradingHistory;
